import React from "react";
import { cn } from "@/lib/utils";
import AnalysisLink from "./AnalysisLink";
import ExpandToggle from "./ExpandToggle";

export type RowData = {
  level: number;
  categoryPath: string;
  category: string;
  stats: number[];
  hasLink?: boolean;
  children?: RowData[];
};

interface TableRowProps {
  row: RowData;
  columns: string[];
  level: number;
  displayMonths: number;
  isSelected: boolean;
  isExpanded: boolean;
  onRowClick?: (row: RowData) => void;
  onLinkClick?: (row: RowData) => void;
  onToggleExpand: (rowId: string) => void;
}

/**
 * テーブル行コンポーネント
 */
const TableRow: React.FC<TableRowProps> = ({
  row,
  columns,
  level,
  displayMonths,
  isSelected,
  isExpanded,
  onRowClick,
  onLinkClick,
  onToggleExpand,
}) => {
  const hasChildren = row.children && row.children.length > 0;
  const monthToMonth = row.stats.toReversed()[0] - row.stats.toReversed()[1];

  const handleClickRow = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onToggleExpand(row.categoryPath);
  };

  const handleLinkClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onLinkClick?.(row);
  };

  return (
    <tr
      className={cn(
        "border-b last:border-none transition-colors",
        isSelected && "bg-yellow-100 hover:bg-yellow-100",
      )}
      onClick={() => onRowClick?.(row)}
    >
      {columns.map((column, colIndex) => (
        <td
          key={`${row.categoryPath}-${column}`}
          className={cn("h-[30px] align-middle", colIndex ? "w-[124px] text-center" : "pl-8")}
        >
          {colIndex === 0 && (
            <div className="flex items-center" style={{ marginLeft: `${level * 8 * 4}px` }}>
              <ExpandToggle
                hasChildren={hasChildren}
                isExpanded={isExpanded}
                onClick={handleClickRow}
                isSelected={isSelected}
              />
              <span>{row.category}</span>
              <AnalysisLink
                hasLink={row.hasLink ?? false}
                onClick={handleLinkClick}
              />
            </div>
          )}
          {colIndex > 0 && colIndex <= displayMonths && (
            <div className="text-black">{row.stats.slice(-displayMonths)[colIndex - 1]}</div>
          )}
          {colIndex === displayMonths + 1 && (
            <div
              className={cn(
                "text-black",
                monthToMonth > 0 && "text-[#5871FE] font-semibold",
                monthToMonth < 0 && "text-[#FE5757] font-semibold",
              )}
            >
              {monthToMonth > 0 && "+"}
              {monthToMonth}
            </div>
          )}
        </td>
      ))}
    </tr>
  );
};

export default TableRow;
